import React from 'react';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth } from '../firebase';
import '../styles/Header.css';

function Header({ onLoginClick }) {
  const navigate = useNavigate();
  const [user, setUser] = React.useState(null);

  React.useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });

    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const getUserFirstName = () => {
    if (!user) return null;
    if (user.displayName) {
      return user.displayName.split(' ')[0];
    }
    if (user.email) {
      return user.email.split('@')[0];
    }
    return 'Reader';
  };

  return (
    <div className="app-header">
      <div className="logo-container" onClick={() => navigate('/')}>
        <img src="/assets/Logo.PNG" alt="Sunny Sideup Storys" className="app-logo" />
        <div className="beta-tag">Beta</div>
      </div>
      <button className="home-button" onClick={() => navigate('/')}>All Stories</button>
      
      {user ? (
        <div className="user-controls">
          <div className="user-greeting">
            Hi, {getUserFirstName()}
          </div>
          <button className="logout-button" onClick={handleLogout}>
            Sign Out
          </button>
        </div>
      ) : (
        <div className="login-signup" onClick={onLoginClick}>
          Login
        </div>
      )}
    </div>
  );
}

export default Header; 